import SpriteSymbol from "../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-soc-pillar-leo",
  "use": "icon-soc-pillar-leo-usage",
  "viewBox": "0 0 1024 1024",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 1024 1024\" fill=\"none\" id=\"icon-soc-pillar-leo\">\r\n  <!-- ④ Leo智能体：圆环 + 智能节点 -->\r\n  <g fill=\"none\" stroke=\"currentColor\" stroke-width=\"64\" stroke-linecap=\"round\" stroke-linejoin=\"round\">\r\n    <circle cx=\"512\" cy=\"512\" r=\"288\" />\r\n    <circle cx=\"512\" cy=\"416\" r=\"40\" />\r\n    <circle cx=\"400\" cy=\"576\" r=\"40\" />\r\n    <circle cx=\"624\" cy=\"576\" r=\"40\" />\r\n    <path d=\"M512 456v72M456 544l56 32M568 544l-56 32\" />\r\n  </g>\r\n</symbol>"
});
var result = sprite.add(symbol);
export default symbol


//////////////////
// WEBPACK FOOTER
// ./src/icons/svg/soc-pillar-leo.svg
// module id = cpDM
// module chunks = 478